export default "__VITE_ASSET__7ea7666b__"